import Image from 'next/image';

import Paragraph from '@/components/renderers/Paragraph';
import Heading from '@/components/renderers/Heading';
import CardCTA from '@/components/CardCTA';
import CardLink from '@/components/CardLink';
import Pill from '@/components/Pill';
import { formatDateWithTime } from '@/utils/date';

export default function EventCard({
  coverImage,
  externalUrl,
  linkPath,
  id,
  starts,
  subTitle,
  title,
  type,
}) {
  const friendlyStartDate = formatDateWithTime(starts);
  const isUpcoming = new Date(starts) > new Date();

  return (
    <article className="flex flex-1" key={id}>
      <CardLink externalUrl={externalUrl} linkPath={linkPath}>
        {coverImage && (
          <div className="mb-2">
            <Image
              src={coverImage.url}
              width={coverImage.width}
              height={coverImage.height}
              alt={coverImage.alt}
              className="rounded-lg"
            />
          </div>
        )}
        <div className="-mt-6">
          <Heading level={4} className="mb-2">
            {title}
          </Heading>
        </div>
        <div className="-mx-1 -my-1 flex flex-wrap">
          <Pill label={type} />
        </div>
        <Paragraph className="flex-grow">{subTitle}</Paragraph>
        <div className="flex items-center justify-between">
          {isUpcoming && <CardCTA label="RSVP" />}
          {friendlyStartDate && (
            <p className="text-cornflower">{friendlyStartDate}</p>
          )}
        </div>
      </CardLink>
    </article>
  );
}
